import { api_url } from "../../utils/constants";
const axios = require('axios').default;

// topic: pass "chat" only for a message the user typed, so the recipient can turn those alerts
// off (Account > Notifications). Without it the alert always goes: other callers send job
// updates (confirmed, quote, reschedule...) through here, some with type "chat" too.
export const sendMessageNotification = (
    responseIdInt,
    respondUserId,
    requestUserId,
    respondMessage,
    object,
    type,
    topic
) => {
    return new Promise((resolve, reject) => {
        const jwtToken = window.localStorage.getItem('jwtToken');

        axios({
            method: "POST",
            url: api_url + "/SendMessageNotification",
            data: {
                responseIdInt: responseIdInt,
                fromUserId: respondUserId,
                userId: requestUserId,
                respondMessage: respondMessage,
                object: object,
                type: type,
                ...(topic ? { topic } : {}),
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + jwtToken,
            },
        })
        .then(
            (response) => resolve(response.data),
            (error) => {
                console.error(error);
                reject(error);
            }
        );
    });
};

export const sendTeamMessageNotification = (
    responseIdInt,
    respondUserId,
    requestUserId,
    respondMessage,
    object,
    type,
    requestIdInt,
    teamId
) => {
    return new Promise((resolve, reject) => {
        axios({
            method: "POST",
            url: api_url + "/public/SendTeamMessageNotification",
            data: {
                responseIdInt: responseIdInt,
                fromUserId: respondUserId,
                userId: requestUserId,
                respondMessage: respondMessage,
                object: object,
                type: type,
                requestIdInt: requestIdInt,
                teamId: teamId
            },
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then(
            (response) => resolve(response.data),
            (error) => {
                console.error(error);
                reject(error);
            }
        );
    });
};

export const sendSharedjobMessageNotification = (
    responseIdInt,
    respondUserId,
    requestUserId,
    respondMessage,
    object,
    type,
    requestIdInt,
    jobTokenId
) => {
    return new Promise((resolve, reject) => {
        axios({
            method: "POST",
            url: api_url + "/public/SendSharedjobMessageNotification",
            data: {
                responseIdInt: responseIdInt,
                fromUserId: respondUserId,
                userId: requestUserId,
                respondMessage: respondMessage,
                object: object,
                type: type,
                requestIdInt: requestIdInt,
                jobTokenId: jobTokenId,
            },
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then(
            (response) => resolve(response.data),
            (error) => {
                console.error(error);
                reject(error);
            }
        );
  });
};

export const clearAllNotification = () => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');
        
        axios({
          method : "POST",
          url :  api_url + "/ClearAllNotification",
          headers:  { "Content-Type": "application/plain", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const updateNotification = (userId, notificationId) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');
        
        var fdd = new FormData();
      	fdd.append('userId', userId);
      	fdd.append('notificationId', notificationId);

        axios({
          method : "POST",
          url :  api_url + "/UpdateNotification",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const skipRequest = (requestIdInt) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');
        
        var fdd = new FormData();
      	fdd.append('requestIdInt', requestIdInt);

        axios({
          method : "POST",
          url :  api_url + "/SkipRequest",
          data : fdd,
          headers:  { "Content-Type": "application/plain", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}